import { track } from './analytics';

// Same pattern as AUTH_SERVER_URL in main.js — env override, hardcoded default.
// Renderer never calls backends directly, but error reporting is fire-and-forget
// so it goes straight to the service rather than through Electron IPC.
const ERROR_REPORTING_URL =
    process.env.REACT_APP_ERROR_REPORTING_URL ||
    'https://errors.mixgoat.com/api/v1/errors';

const ERROR_REPORTING_CLIENT_KEY =
    process.env.REACT_APP_ERROR_REPORTING_CLIENT_KEY || '';

const isElectron = typeof window !== 'undefined' && !!window.electron;

export function reportError(err, context) {
    // Analytics is a best-effort side-channel; track() is self-guarding but keep
    // the property derivation out of the reporting try/catch below.
    track('client_error', {
        component: context?.component || context?.type || null,
        error_code: err?.code || context?.code || null,
        message_excerpt: String(err?.message || err).slice(0, 120),
        surface: context?.surface || null,
        status: context?.status ?? null,
        request_id: context?.requestId || null,
    });
    try {
        const body = JSON.stringify({
            message: err?.message || String(err),
            stack: err?.stack || null,
            version: process.env.REACT_APP_VERSION || null,
            platform: isElectron ? 'electron-renderer' : 'web',
            environment: process.env.NODE_ENV || 'production',
            context: context || null,
        });
        fetch(ERROR_REPORTING_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Key': ERROR_REPORTING_CLIENT_KEY,
            },
            body,
            keepalive: true, // survives page unload
        }).catch(() => {});
    } catch (e) {
        // never throw from reportError
    }
}
